import imask from 'imask/holder'
import type { InputMask } from 'imask'

import 'imask/masked/pattern'

export function getMask(mask: string, element: HTMLInputElement): InputMask<{}> {
    const map: Record<string, (element: HTMLInputElement) => InputMask<{}>> = {
        "date": date,
        "price": price,
        "frontLetters": frontLetters
    };

    return map[mask](element);
}

function frontLetters(element: HTMLInputElement): InputMask<{}> {
    return imask(element, {
        mask: "a[aaaa]",
        prepare: (str: string) => str.toUpperCase(),
    });
}

function date(element: HTMLInputElement): InputMask<{}> {
    return imask(element, {
        mask: "00-00-0000"
    });
}

function price(element: HTMLInputElement): InputMask<{}> {
    return imask(element, {
        mask: "0[0000000],00",
    });
}